import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, unref as _unref, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex items-center pagination-content" }
const _hoisted_2 = { class: "img-container emphable-img" }
const _hoisted_3 = { class: "detail-area" }
const _hoisted_4 = { class: "app-low-top" }
const _hoisted_5 = { class: "item-title" }
const _hoisted_6 = { class: "app-low" }
const _hoisted_7 = { class: "detail-label" }
const _hoisted_8 = { class: "low-area-list" }
const _hoisted_9 = { class: "detail-info" }
const _hoisted_10 = { class: "detail-info" }
const _hoisted_11 = { class: "detail-info" }
const _hoisted_12 = { class: "detail-info" }
const _hoisted_13 = { class: "detail-info" }
const _hoisted_14 = { class: "detail-info" }
const _hoisted_15 = { class: "similar-product-btnarea" }
const _hoisted_16 = { class: "supplier-area q-mt-md" }
const _hoisted_17 = { class: "full-width row q-gutter-sm" }
const _hoisted_18 = { class: "q-pt-xs" }
const _hoisted_19 = { class: "filter-select" }
const _hoisted_20 = { class: "flex" }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = ["href"]
const _hoisted_23 = {
  key: 0,
  class: "q-mb-none text-left"
}
const _hoisted_24 = {
  key: 1,
  class: "q-mb-none"
}
const _hoisted_25 = {
  key: 0,
  class: "table-note"
}
const _hoisted_26 = {
  key: 1,
  class: "table-note",
  style: {"align-items":"center","display":"flex"}
}
const _hoisted_27 = {
  key: 0,
  class: "similar-product-container"
}
const _hoisted_28 = {
  key: 1,
  class: "similar-message"
}

import Loading from 'quasar/src/plugins/Loading.js';;
import { ref, computed, inject } from 'vue';
import { useRouter } from 'vue-router';
import http from '../../common/axios-common';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import OrderQuotableCode from '../../common/code/OrderQuotableCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import countOrderQuotableKey from '../../common/order-quotable-key';
import commaFormat from '../../common/utils/numberUtils';
import OrderButton from '../button/OrderButton.vue';
import QuotableButton from '../button/QuotableButton.vue';
import SimilarCard from '../card/SimilarCard.vue';
import AtomImage from '../images/AtomImage.vue';
import ApplyLowLabel from '../label/ApplyLowLabel.vue';
import AlertDialog from './AlertDialog.vue';
import loginUserStore from '../../store/loginUserStore';

interface Supplier {
  label: string;
  value: string;
}

interface Props {
  // ATTOIDリスト
  resultAttoIdList: Array<string>;
  // 選択されたATTOID
  selectAttoId: string;
  // 詳細結果ダイアログ表示フラグ
  detailResultFlg: boolean;
  // 試薬フラグ
  reagentFlg: boolean;
  // カテゴリー
  categories: number[];
  // サプライヤ
  suppliers: Supplier[];
}
interface HideableColumn {
  name: string;
  label: string;
}

// 構造式詳細
interface DetailStructure {
  attoId: string;
  reg_group_code: string;
  reg_group_name: string;
  prtr_name: string;
  ishl_name: string;
  structure: string;
  structure_txt: string;
  logp: string;
  hbondD: string;
  hbondA: string;
  rotBond: string;
  psa: string;
  heavyAtom: string;
}

// 検索結果
interface SimilarResult {
  atto_id: string;
  atto_supplier_count: number;
  order_count: number;
  condition_id: number;
  result_id: number;
  result_number: number;
  structure: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DetailResultDialog',
  props: {
    resultAttoIdList: {},
    selectAttoId: {},
    detailResultFlg: { type: Boolean },
    reagentFlg: { type: Boolean },
    categories: {},
    suppliers: {}
  },
  emits: ['closeDetailDialog', 'detailResultDialogFlg'],
  setup(__props: any, { emit: __emit }) {

const router = useRouter();

// サプライヤInterface
const props = __props;
const emit = __emit;

// 注文問い合わせ件数取得
const countOrderQuotable = inject(countOrderQuotableKey);

// 初期表示読み込み時「データがありません」を非表示にするためのフラグ(falseで表示)
const hideNoDataFlg = ref(true);

// ダイアログ表示フラグ
const detailResultFlgComputed = computed(() => props.detailResultFlg);

// パンチアウト種別
const roleType = ref('');
const poType = ref('');

// ログイン情報取得
const getLoginUser = () => {
  const loginUser = loginUserStore();
  http
    .post('/ctp001001/loginUser')
    .then((response) => {
      // 異常終了の場合
      if (response.data.common.status === ResultStatusCode.ERROR) {
        router.push({ name: 'error' });
      } else {
        // ログインユーザー情報をstoreに設定
        loginUser.setLoginUser(response.data.loginUser);
        // ユーザーID設定
        roleType.value = loginUser.role;
        poType.value = loginUser.po_type;
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    });
};

// ATTO ID一覧
const attoIdList = ref<Array<string>>(props.resultAttoIdList);
const attoIdListComputed = computed({
  get: () => attoIdList.value || props.resultAttoIdList,
  set: (value) => {
    attoIdList.value = value;
  },
});

// ATTO ID
const attoId = ref<string>(props.selectAttoId);
const selectAttoIdComputed = computed({
  get: () => attoId.value || props.selectAttoId,
  set: (value) => {
    attoId.value = value;
  },
});

// カラム表示機能
const detailStructure = ref<DetailStructure>({
  attoId: '',
  reg_group_code: '',
  reg_group_name: '',
  prtr_name: '',
  ishl_name: '',
  structure: '',
  structure_txt: '',
  logp: '',
  hbondD: '',
  hbondA: '',
  rotBond: '',
  psa: '',
  heavyAtom: '',
});

const supplierList = ref<Array<string>>([]);

// サプライヤフィルター
const supplierFilter = ref<string>('');

// 取扱サプライヤのテーブルカラム(試薬用・大量用でカラムが切り替わる)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const supplierColumns = ref<Array<any>>([]);
// 取扱サプライヤのテーブル一覧
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const supplierRows = ref<Array<any>>([]);

// 注文問い合わせフラグ
const orderQuotableFlg = ref<string>('2');

// ダイアログ内のデータが検索結果の類似品かどうか
const showSimilarDataFlg = ref(false);

// 試薬カラム（テーブルカラム）
const REAGENT_COLUMS = [
  {
    name: 'resultDetailAttoId',
    label: '',
    field: 'resultDetailAttoId',
    display: false,
  },
  {
    name: 'orderQuotable',
    label: '',
    field: 'orderQuotable',
    required: true,
    sortable: true,
  },
  {
    name: 'supplier_name',
    required: true,
    label: 'サプライヤ',
    align: 'left',
    sortable: true,
    field: 'supplier_name',
  },
  {
    name: 'id_number',
    label: 'サプライヤ商品コード',
    align: 'left',
    sortable: true,
    field: 'id_number',
  },
  {
    name: 'cas',
    label: 'CAS No.',
    align: 'left',
    sortable: true,
    field: 'cas',
  },
  {
    name: 'name',
    label: '化学名',
    align: 'left',
    sortable: true,
    field: 'name',
  },
  {
    name: 'capacity',
    label: '容量',
    align: 'left',
    sortable: true,
    sort: (a: string, b: string) =>
      Number(a.split(/[^0-9]/g).join('')) - Number(b.split(/[^0-9]/g).join('')),
    field: 'capacity',
  },
  {
    name: 'use',
    label: '用途',
    align: 'left',
    sortable: true,
    field: 'use',
  },
  {
    name: 'total_amount',
    label: '在庫量（現地）',
    align: 'left',
    sortable: true,
    field: 'total_amount',
  },
  {
    // 納入価格項目値
    name: 'sellingPrice',
    label: '納入価格（税抜）',
    align: 'left',
    sortable: true,
    sort: (a: string, b: string) =>
      Number(a.split(/[^0-9]/g).join('')) - Number(b.split(/[^0-9]/g).join('')),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    field: (row: any) =>
      row.sellingPrice ? `¥${commaFormat(Number(row.sellingPrice))}` : '要問合せ',
    classes: 'text-right',
  },
  {
    name: 'deliveryTime',
    label: '納期',
    align: 'left',
    sortable: true,
    field: 'deliveryTime',
  },
  {
    name: 'purity',
    label: '純度',
    align: 'left',
    sortable: true,
    field: 'purity',
    classes: 'text-right',
  },
  {
    name: 'mdl',
    label: 'MDL',
    align: 'left',
    sortable: true,
    field: 'mdl',
  },
];

// 大量品カラム（テーブルカラム）
const BULK_COLUMS = [
  {
    name: 'resultDetailAttoId',
    label: '',
    field: 'resultDetailAttoId',
    display: false,
  },
  {
    name: 'orderQuotable',
    label: '',
    field: 'orderQuotable',
    required: true,
    sortable: true,
  },
  {
    name: 'supplier_name',
    required: true,
    label: 'サプライヤ',
    align: 'left',
    sortable: true,
    field: 'supplier_name',
  },
  {
    name: 'id_number',
    label: 'サプライヤ商品コード',
    align: 'left',
    sortable: true,
    field: 'id_number',
  },
  {
    name: 'cas',
    label: 'CAS No.',
    align: 'left',
    sortable: true,
    field: 'cas',
  },
  {
    name: 'name',
    label: '化学名',
    align: 'left',
    sortable: true,
    field: 'name',
  },
  {
    name: 'capacity',
    label: '容量',
    align: 'left',
    sortable: true,
    field: 'capacity',
  },
  {
    name: 'use',
    label: '用途',
    align: 'left',
    sortable: true,
    field: 'use',
  },
  {
    name: 'packing',
    label: '荷姿',
    align: 'left',
    sortable: true,
    field: 'packing',
  },
];

// 試薬表示カラム
const REAGENT_VISIBLE_COLUMS = [
  'orderQuotable',
  'supplier_code',
  'id_number',
  'cas',
  'name',
  'capacity',
  'use',
  'total_amount',
  'sellingPrice',
  'deliveryTime',
  'purity',
  'mdl',
];

// 大量品表示カラム
const BULK_VISIBLE_COLUMS = [
  'orderQuotable',
  'supplier_code',
  'id_number',
  'cas',
  'name',
  'capacity',
  'use',
  'packing',
];

// 試薬非表示可能カラム
const REAGENT_HIDEABLE_COLUMS = [
  {
    name: 'id_number',
    label: 'サプライヤ商品コード',
  },
  {
    name: 'cas',
    label: 'CAS No.',
  },
  {
    name: 'name',
    label: '化学名',
  },
  {
    name: 'capacity',
    label: '容量',
  },
  {
    name: 'use',
    label: '用途',
  },
  {
    name: 'total_amount',
    label: '在庫量（現地）',
  },
  {
    name: 'sellingPrice',
    label: '納入価格（税抜）',
  },
  {
    name: 'deliveryTime',
    label: '納期',
  },
  {
    name: 'purity',
    label: '純度',
  },
  {
    name: 'mdl',
    label: 'MDL',
  },
];

// 大量品非表示可能カラム
const BULK_HIDEABLE_COLUMS = [
  {
    name: 'id_number',
    label: 'サプライヤ商品コード',
  },
  {
    name: 'cas',
    label: 'CAS No.',
  },
  {
    name: 'name',
    label: '化学名',
  },
  {
    name: 'capacity',
    label: '容量',
  },
  {
    name: 'use',
    label: '用途',
  },
  {
    name: 'packing',
    label: '荷姿',
  },
];

// カラム表示設定
const visibleColumns = ref<Array<string>>([]);
// カラム非表示設定
const hideableColumns = ref<Array<HideableColumn>>([]);

// 類似品の商品情報
const simDataList = ref<Array<SimilarResult>>([]);

// 類似品のATTOID一覧
const simAttoIdList = ref<Array<string>>([]);

// 類似品一覧表示ステータス（0:非表示、1:表示、2:類似品なし）
const simularProductDisplayStatus = ref(0);
// ページャー表示フラグ
const showResultPagerFlg = ref(true);
// ダイアログtop要素
const dialogTopElement = ref<HTMLImageElement>();
// 類似品要素
const simularElement = ref<HTMLImageElement>();

// ダイアログ表示
const dialogDispFlg = ref<boolean>(false);
// Dialog表示レベル
const dialogLevel = ref('');
// ダイアログテキスト
const dialogText = ref<Array<string>>(['']);
// ダイアログタイトル
const dialogTitle = ref<string>('');

// ダイアログを閉じる
const closeDialog = () => {
  dialogDispFlg.value = false;
  emit('detailResultDialogFlg', false);
};

// テーブル初期設定
const initTable = () => {
  getLoginUser();
  // 選択された品目のユニークなサプライヤ情報をもとに取扱サプライヤのデータをセット
  if (props.reagentFlg) {
    supplierColumns.value = REAGENT_COLUMS;
    visibleColumns.value = REAGENT_VISIBLE_COLUMS;
    hideableColumns.value = REAGENT_HIDEABLE_COLUMS;
  } else {
    supplierColumns.value = BULK_COLUMS;
    visibleColumns.value = BULK_VISIBLE_COLUMS;
    hideableColumns.value = BULK_HIDEABLE_COLUMS;
  }

  supplierRows.value = [];
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const customSort = (rows: readonly any[], sortBy: string, descending: boolean) => {
  const data = [...rows];

  if (sortBy) {
    data.sort((a, b) => {
      let x = a;
      let y = b;

      let status = 0;
      if (x.orderQuotable !== y.orderQuotable) {
        status = -1;
        if (x.orderQuotable > y.orderQuotable) {
          status = 1;
        }
        return status;
      }
      x = descending ? b : a;
      y = descending ? a : b;

      status = 0;
      if (x[sortBy] === null && y[sortBy] === null) {
        status = 0;
      } else if (x[sortBy] === null || x[sortBy] === '要問合せ') {
        status = descending ? -1 : 1;
      } else if (y[sortBy] === null || y[sortBy] === '要問合せ') {
        status = descending ? 1 : -1;
      } else if (sortBy === 'capacity' || sortBy === 'sellingPrice') {
        status =
          Number(x[sortBy].split(/[^0-9.]/g).join('')) -
          Number(y[sortBy].split(/[^0-9.]/g).join(''));
      } else if (x[sortBy] > y[sortBy]) {
        status = 1;
      } else if (x[sortBy] < y[sortBy]) {
        status = -1;
      } else {
        status = 0;
      }

      return status;
    });
  }
  return data;
};

// 詳細結果検索
const detailSearch = () => {
  // Loading Start
  Loading.show();

  const formData = new FormData();
  formData.append('attoId', attoId.value);
  props.categories.forEach((category) => formData.append('sup_category_ids', category.toString()));
  props.suppliers.forEach((supplier: { label: string; value: string }) => {
    formData.append('supplier_ids', supplier.value);
  });

  http
    .post('/csr002004/detailReslut', formData)
    .then((response) => {
      if (response.data.common.status === ResultStatusCode.ERROR) {
        if (response.data.common.detail_status === DetailResultStatusCode.MAX_MOL_ERROR) {
          // 商品上限値超過エラー
          dialogLevel.value = 'error';
          dialogTitle.value = '商品数上限件数エラー';
          dialogText.value = [
            '１回の注文・問い合わせで追加可能な商品数は３００商品までとなっております。',
          ];
          dialogDispFlg.value = true;
        } else if (
          response.data.common.detail_status === DetailResultStatusCode.CHECK_ATTOID_ERROR
        ) {
          // ATTO_ID取得エラー
          dialogLevel.value = 'error';
          dialogTitle.value = '化合物に変更がありました';
          dialogText.value = [
            '当化合物は取り扱い不可の分類に変更されたため、詳細結果画面に表示できません。',
            '詳細結果画面を閉じて、検索画面から再検索してください。',
          ];
          dialogDispFlg.value = true;
        } else if (
          response.data.common.detail_status === DetailResultStatusCode.PRODUCTS_NOT_AVAILABLE_ERROR
        ) {
          // 取り扱い不可商品エラー
          dialogLevel.value = 'error';
          dialogText.value = [
            '該当化合物は取り扱い不可の分類に変更されたため、詳細結果画面に表示できません。',
            '詳細結果画面を閉じて、検索画面から再検索してください。',
          ];
          dialogTitle.value = '取り扱い商品に変更がありました';
          dialogDispFlg.value = true;
          // 初期値設定
          detailStructure.value = {
            attoId: '',
            reg_group_code: '',
            reg_group_name: '',
            prtr_name: '',
            ishl_name: '',
            structure: '',
            structure_txt: '',
            logp: '',
            hbondD: '',
            hbondA: '',
            rotBond: '',
            psa: '',
            heavyAtom: '',
          };
          supplierRows.value = [];
          supplierList.value = [];
        } else {
          router.push({ name: 'error' });
        }
      } else {
        detailStructure.value = response.data.detailStructure;
        supplierRows.value = response.data.searchResultInfo;
        supplierList.value = response.data.supplierNameList;
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        //  エラー画面に遷移
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // 注文/問合選択状態を一旦フラットにする
      orderQuotableFlg.value = OrderQuotableCode.OTHER;

      // 商品の状態を確認しボタンの選択状態を決める
      for (let i = 0; i < supplierRows.value.length; i += 1) {
        if (supplierRows.value[i].is_ordered === '1') {
          // 注文済み && 注文可能商品の場合に問合せボタンを非活性にしてbreak
          if (supplierRows.value[i].orderQuotable === OrderQuotableCode.ORDER) {
            orderQuotableFlg.value = OrderQuotableCode.ORDER;
            break;
          }
          // 問合せ済み && 問合せ可能商品の場合に全ての注文ボタンを非活性にしてbreak
          if (supplierRows.value[i].orderQuotable === OrderQuotableCode.QUOTABLE) {
            orderQuotableFlg.value = OrderQuotableCode.QUOTABLE;
            break;
          }
        }
      }
      // 注文商品の場合
      if (orderQuotableFlg.value === OrderQuotableCode.ORDER) {
        for (let i = 0; i < supplierRows.value.length; i += 1) {
          // 注文商品が1つでも存在する場合は、問合せボタンを非選択状態にする
          if (supplierRows.value[i].orderQuotable === OrderQuotableCode.QUOTABLE) {
            supplierRows.value[i].is_ordered = '0';
          }
        }
      }
      // Loading End
      Loading.hide();
      hideNoDataFlg.value = false;
    });
};

// 類似品取得
const getSimilar = () => {
  // Loading Start
  Loading.show();

  const formData = new FormData();
  formData.append('type', 'STRUCTURE');
  formData.append('extension', 'STRUCTURE');
  formData.append('structure', detailStructure.value.structure_txt);
  formData.append('searchType', 'similar');
  formData.append('attoId', attoId.value);
  formData.append('threshold', '0.7');
  props.categories.forEach((category) => formData.append('sup_category_ids', category.toString()));
  props.suppliers.forEach((supplier: { label: string; value: string }) => {
    formData.append('supplier_ids', supplier.value);
  });

  http
    .post('/csr002002/structureSerach', formData)
    .then((response) => {
      if (response.data.common.status === ResultStatusCode.ERROR) {
        router.push({ name: 'error' });
      } else {
        simAttoIdList.value = response.data.searchResultInfo.attoIdList;
        simDataList.value = response.data.searchResultInfo[0].searchResultDetailList;
        // 類似品一覧表示
        if (simDataList.value !== null) {
          simularProductDisplayStatus.value = 1;
        } else {
          simularProductDisplayStatus.value = 2;
        }
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        //  エラー画面に遷移
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * 注文問合
 * @param resultDetailAttoId 詳細結果で選択したATTO_ID
 * @param orderedFlg ボタン選択状態(0:未選択 1:選択済)
 * @param orderQuotableFlag 画面表示モード
 */
const orderQuotable = (
  resultDetailAttoId: string,
  orderedFlg: string,
  orderQuotableFlag: string
) => {
  // Loading Start
  Loading.show();

  const formData = new FormData();
  formData.append('result_detail_atto_id', resultDetailAttoId);
  formData.append('orderQuotable', orderQuotableFlag);
  formData.append('is_ordered', orderedFlg);
  formData.append('attoId', attoId.value);

  http
    .post('/csr002004/orderQuotable', formData)
    .then((response) => {
      if (response.data.common.status === ResultStatusCode.ERROR) {
        if (response.data.common.detail_status === DetailResultStatusCode.MAX_MOL_ERROR) {
          // 商品上限値超過エラー
          dialogLevel.value = 'error';
          dialogTitle.value = '商品数上限件数エラー';
          dialogText.value = [
            '１回の注文・問い合わせで追加可能な商品数は３００商品までとなっております。',
          ];
          dialogDispFlg.value = true;
        } else if (response.data.common.detail_status === DetailResultStatusCode.CHECK_MOL_ERROR) {
          // 商品チェックエラー
          dialogLevel.value = 'error';
          dialogTitle.value = '商品追加エラー';
          dialogText.value = ['すでに注文・問合せされている商品のため選択できません。'];
          dialogDispFlg.value = true;
        } else {
          // エラー画面遷移
          router.push({ name: 'error' });
        }
      }
      // 注文問い合わせ件数再取得
      countOrderQuotable?.();
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // エラー画面に遷移
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // 問合が取り消されたとき
      if (orderedFlg === '0' && orderQuotableFlag === OrderQuotableCode.QUOTABLE) {
        // ボタンを全て活性化に戻す
        orderQuotableFlg.value = OrderQuotableCode.OTHER;
      }
      // 注文が取り消されたとき
      if (orderedFlg === '0' && orderQuotableFlag === OrderQuotableCode.ORDER) {
        let count = 0;
        // 選択済みの注文商品の存在を確認
        for (let i = 0; i < supplierRows.value.length; i += 1) {
          // ボタンが選択済みかつ注文の場合
          if (
            supplierRows.value[i].is_ordered === '1' &&
            supplierRows.value[i].orderQuotable === OrderQuotableCode.ORDER
          ) {
            count += 1;
          }
        }
        // 注文商品が0件の場合、ボタンを全て活性化に戻す
        if (count === 0) {
          orderQuotableFlg.value = OrderQuotableCode.OTHER;
        }
      }
      // Loading End
      Loading.hide();
    });
};

// ダイアログ内のサプライヤテーブルのフィルターの選択を解除する
const filterClear = () => {
  supplierFilter.value = '';
};

// 取扱テーブルのフィルタリング
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const customFilter = (rows: any, terms: any) => {
  const lowerSearch = terms || '';

  // rowsの中身分ループ処理してフィルタリングを実行
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const filteredRows = rows.filter((row: any) => {
    let ans = false;
    let s1 = true;

    if (lowerSearch !== '') {
      s1 = false;
      // サプライヤ名に入力された文字列が一致するかどうかの判定
      if (row.supplier_name && row.supplier_name.includes(lowerSearch)) {
        s1 = true;
      }
    }

    if (s1) {
      ans = true;
    }
    return ans;
  });
  return filteredRows;
};

// ダイアログ内の類似品詳細表示ボタン押下時
const resultSimdataDetail = (selectAttoId: string) => {
  simularProductDisplayStatus.value = 0;
  attoId.value = selectAttoId;
  attoIdList.value = simAttoIdList.value;
  // 詳細検索
  detailSearch();
  // ページャーを非表示
  showResultPagerFlg.value = false;
  // フィルターのクリア
  filterClear();
  // スクロール
  dialogTopElement.value?.scrollIntoView(true);
};

// テーブル内の注文ボタン押下時
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const detailOrderBtn = (row: any) => {
  if (row.is_ordered === '0') {
    supplierRows.value[supplierRows.value.findIndex((object) => object === row)].is_ordered = '1';
    orderQuotableFlg.value =
      supplierRows.value[supplierRows.value.findIndex((object) => object === row)].orderQuotable;
    // 注文問合取消
    orderQuotable(row.resultDetailAttoId, '1', orderQuotableFlg.value);
  } else {
    supplierRows.value[supplierRows.value.findIndex((object) => object === row)].is_ordered = '0';
    orderQuotableFlg.value =
      supplierRows.value[supplierRows.value.findIndex((object) => object === row)].orderQuotable;
    // 注文問合取消
    orderQuotable(row.resultDetailAttoId, '0', orderQuotableFlg.value);
  }
};

// 類似ボタン押下時
const simProDisp = () => {
  simDataList.value = [];
  // 類似品検索
  getSimilar();
  showSimilarDataFlg.value = true;
  // スクロール
  setTimeout(() => simularElement.value?.scrollIntoView(true), 800);
};

// 品目詳細ダイアログを閉じる
const dialogClose = () => {
  // フィルターを使用していた場合はフィルターをクリア
  filterClear();
  showSimilarDataFlg.value = false;
  // ページャーを非表示
  showResultPagerFlg.value = true;
  // 類似品目の表示を非表示にする
  simularProductDisplayStatus.value = 0;
  emit('closeDetailDialog');
};

// 品目詳細の前の品目に移動ボタン押下時
const previousItem = (itemNumber: number) => {
  selectAttoIdComputed.value = attoIdListComputed.value[itemNumber];
  // 詳細検索
  detailSearch();
  // フィルターを使用していた場合はフィルターをクリア
  filterClear();
  // 類似品一覧非表示
  simularProductDisplayStatus.value = 0;
};

// 品目詳細の次の品目に移動ボタン押下時
const nextItem = (itemNumber: number) => {
  selectAttoIdComputed.value = attoIdListComputed.value[itemNumber];
  // 詳細検索
  detailSearch();
  // フィルターを使用していた場合はフィルターをクリア
  filterClear();
  // 類似品一覧非表示
  simularProductDisplayStatus.value = 0;
};

// 初期表示
initTable();
detailSearch();

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: detailResultFlgComputed.value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((detailResultFlgComputed).value = $event)),
    class: "itemdetail-dialog",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "row items-center q-pb-none result-dialog-header" }, {
            default: _withCtx(() => [
              _cache[6] || (_cache[6] = _createElementVNode("h3", {
                class: "text-h6",
                style: {"width":"130px"}
              }, "詳細結果", -1)),
              _createElementVNode("div", {
                class: "pagination",
                style: _normalizeStyle(!showResultPagerFlg.value ? 'display:none' : '')
              }, [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_q_btn, {
                    icon: "mdi-less-than",
                    class: _normalizeClass(
                'pager-icon ' +
                (attoIdListComputed.value.indexOf(selectAttoIdComputed.value) === 0 ? 'disabled' : '')
              ),
                    disabled: attoIdListComputed.value.indexOf(selectAttoIdComputed.value) === 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (previousItem(attoIdListComputed.value.indexOf(selectAttoIdComputed.value) - 1)))
                  }, null, 8, ["class", "disabled"]),
                  _createElementVNode("p", null, [
                    _createElementVNode("span", null, _toDisplayString(attoIdListComputed.value.indexOf(selectAttoIdComputed.value) + 1), 1),
                    _createTextVNode(" / " + _toDisplayString(attoIdListComputed.value.length) + " 件目 ", 1)
                  ]),
                  _createVNode(_component_q_btn, {
                    icon: "mdi-greater-than",
                    class: _normalizeClass(
                'pager-icon ' +
                (attoIdListComputed.value.indexOf(selectAttoIdComputed.value) + 1 === attoIdListComputed.value.length
                  ? 'disabled'
                  : '')
              ),
                    disabled: 
                attoIdListComputed.value.indexOf(selectAttoIdComputed.value) + 1 === attoIdListComputed.value.length
              ,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (nextItem(attoIdListComputed.value.indexOf(selectAttoIdComputed.value) + 1)))
                  }, null, 8, ["class", "disabled"])
                ])
              ], 4),
              _withDirectives(_createVNode(_component_q_btn, {
                icon: "close",
                flat: "",
                round: "",
                dense: "",
                onClick: dialogClose
              }, null, 512), [
                [_directive_close_popup]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "result-info-area" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                ref_key: "dialogTopElement",
                ref: dialogTopElement,
                class: "item-area"
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(AtomImage, {
                    exatoms: detailStructure.value.structure
                  }, null, 8, ["exatoms"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("p", null, _toDisplayString(detailStructure.value.attoId), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("p", _hoisted_7, [
                        _cache[8] || (_cache[8] = _createTextVNode(" 適用法令： ")),
                        _createVNode(_component_q_tooltip, {
                          class: "bg-black shadow-4",
                          anchor: "bottom end",
                          self: "top middle"
                        }, {
                          default: _withCtx(() => _cache[7] || (_cache[7] = [
                            _createTextVNode("毒物、劇物：毒物及び劇物取締法"),
                            _createElementVNode("br", null, null, -1),
                            _createTextVNode("PRTR法　第一種指定化学物質：化学物質排出把握管理促進法 第二条第２項"),
                            _createElementVNode("br", null, null, -1),
                            _createTextVNode("PRTR法　第二種指定化学物質：化学物質排出把握管理促進法 第二条第３項"),
                            _createElementVNode("br", null, null, -1),
                            _createTextVNode("名称等を表示すべき危険物及び有害物：労働安全衛生法 第五十七条、第五十七条の二")
                          ])),
                          _: 1
                        })
                      ]),
                      _createVNode(ApplyLowLabel, {
                        "classification-code": detailStructure.value.reg_group_code,
                        "reg-name": detailStructure.value.reg_group_name,
                        "prtr-name": detailStructure.value.prtr_name,
                        "ishl-name": detailStructure.value.ishl_name
                      }, null, 8, ["classification-code", "reg-name", "prtr-name", "ishl-name"])
                    ])
                  ]),
                  _createElementVNode("table", _hoisted_8, [
                    _createElementVNode("tr", null, [
                      _cache[9] || (_cache[9] = _createElementVNode("td", { class: "detail-label first" }, [
                        _createElementVNode("p", null, "LogP")
                      ], -1)),
                      _createElementVNode("td", _hoisted_9, [
                        _createElementVNode("p", null, _toDisplayString(detailStructure.value.logp), 1)
                      ]),
                      _cache[10] || (_cache[10] = _createElementVNode("td", { class: "space" }, null, -1)),
                      _cache[11] || (_cache[11] = _createElementVNode("td", { class: "detail-label" }, [
                        _createElementVNode("p", null, "Hbond A")
                      ], -1)),
                      _createElementVNode("td", _hoisted_10, [
                        _createElementVNode("p", null, _toDisplayString(detailStructure.value.hbondA), 1)
                      ]),
                      _cache[12] || (_cache[12] = _createElementVNode("td", { class: "space" }, null, -1)),
                      _cache[13] || (_cache[13] = _createElementVNode("td", { class: "detail-label" }, [
                        _createElementVNode("p", null, "Hbond D")
                      ], -1)),
                      _createElementVNode("td", _hoisted_11, [
                        _createElementVNode("p", null, _toDisplayString(detailStructure.value.hbondD), 1)
                      ]),
                      _cache[14] || (_cache[14] = _createElementVNode("td", null, null, -1))
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[15] || (_cache[15] = _createElementVNode("td", { class: "detail-label first" }, [
                        _createElementVNode("p", null, "Rot bond")
                      ], -1)),
                      _createElementVNode("td", _hoisted_12, [
                        _createElementVNode("p", null, _toDisplayString(detailStructure.value.rotBond), 1)
                      ]),
                      _cache[16] || (_cache[16] = _createElementVNode("td", { class: "space" }, null, -1)),
                      _cache[17] || (_cache[17] = _createElementVNode("td", { class: "detail-label" }, [
                        _createElementVNode("p", null, "PSA")
                      ], -1)),
                      _createElementVNode("td", _hoisted_13, [
                        _createElementVNode("p", null, _toDisplayString(detailStructure.value.psa), 1)
                      ]),
                      _cache[18] || (_cache[18] = _createElementVNode("td", { class: "space" }, null, -1)),
                      _cache[19] || (_cache[19] = _createElementVNode("td", { class: "detail-label" }, [
                        _createElementVNode("p", null, "HeavyAtom")
                      ], -1)),
                      _createElementVNode("td", _hoisted_14, [
                        _createElementVNode("p", null, _toDisplayString(detailStructure.value.heavyAtom), 1)
                      ]),
                      _cache[20] || (_cache[20] = _createElementVNode("td", null, null, -1))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  (simularProductDisplayStatus.value === 0 && detailStructure.value.attoId !== '')
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 0,
                        color: "primary",
                        outline: "",
                        class: "similar-product-btn",
                        label: "この商品に関する類似品を表示する",
                        onClick: simProDisp
                      }))
                    : _createCommentVNode("", true)
                ])
              ], 512),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", {
                  class: _normalizeClass(
              'labelbtn-table-area chem-table-area ' +
              (supplierRows.value.length === 0 ? 'table-nodata' : '')
            )
                }, [
                  _createVNode(_component_q_table, {
                    class: "my-sticky-header-column-detail-table",
                    rows: supplierRows.value,
                    columns: supplierColumns.value,
                    flat: "",
                    dense: "",
                    separator: "cell",
                    "hide-no-data": hideNoDataFlg.value,
                    "no-data-label": "データがありません。",
                    "no-results-label": "検索条件に該当する商品はありませんでした。検索結果にご不明な点がございましたら、お問い合わせください。",
                    "rows-per-page-options": [10, 20, 50, 0],
                    "rows-per-page-label": "件表示",
                    "pagination-label": 
                (firstRowIndex, endRowIndex, totalRowsNumber) => {
                  return `${totalRowsNumber} 件中 ${firstRowIndex}～${endRowIndex} 件表示`;
                }
              ,
                    filter: supplierFilter.value,
                    "filter-method": customFilter,
                    "visible-columns": visibleColumns.value,
                    "sort-method": customSort
                  }, {
                    "no-data": _withCtx(({ message }) => [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_q_icon, {
                          size: "24px",
                          name: "mdi-alert-circle-outline"
                        }),
                        _createElementVNode("span", _hoisted_18, _toDisplayString(message), 1)
                      ])
                    ]),
                    top: _withCtx(() => [
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_q_select, {
                          modelValue: supplierFilter.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((supplierFilter).value = $event)),
                          options: supplierList.value,
                          square: "",
                          outlined: "",
                          "new-value-mode": "add-unique",
                          label: "フィルター（サプライヤ）",
                          dense: "",
                          "options-dense": "",
                          class: "column-filter"
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_q_btn, {
                              outlined: "",
                              icon: "mdi-eraser",
                              class: "cursor-pointer filter-clear",
                              label: "クリア",
                              onClick: _withModifiers(filterClear, ["stop"])
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options"]),
                        _createVNode(_component_q_select, {
                          modelValue: visibleColumns.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((visibleColumns).value = $event)),
                          multiple: "",
                          outlined: "",
                          dense: "",
                          "options-dense": "",
                          "display-value": "カラム表示設定",
                          "emit-value": "",
                          "map-options": "",
                          options: hideableColumns.value,
                          "option-value": "name",
                          color: "primary",
                          class: "column-disp q-btn"
                        }, null, 8, ["modelValue", "options"])
                      ])
                    ]),
                    "header-cell-orderQuotable": _withCtx(() => [
                      _createVNode(_component_q_th, { class: "table-btn-area" })
                    ]),
                    "body-cell-orderQuotable": _withCtx((body) => [
                      _createVNode(_component_q_td, {
                        class: _normalizeClass(
                    'table-btn-area ' +
                    (body.row.is_ordered === '1' ||
                    (orderQuotableFlg.value === _unref(OrderQuotableCode).QUOTABLE &&
                      body.row.orderQuotable === _unref(OrderQuotableCode).OTHER)
                      ? 'deleted'
                      : '')
                  )
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_20, [
                            (body.row.orderQuotable === _unref(OrderQuotableCode).ORDER)
                              ? (_openBlock(), _createBlock(OrderButton, {
                                  key: 0,
                                  "is-selected": body.row.is_ordered,
                                  "order-quotable-flg": orderQuotableFlg.value,
                                  disabled: poType.value === 'PO_RE_ARIBA',
                                  onOrder: ($event: any) => (detailOrderBtn(body.row))
                                }, null, 8, ["is-selected", "order-quotable-flg", "disabled", "onOrder"]))
                              : (body.row.orderQuotable === _unref(OrderQuotableCode).QUOTABLE)
                                ? (_openBlock(), _createBlock(QuotableButton, {
                                    key: 1,
                                    "is-selected": body.row.is_ordered,
                                    "order-quotable-flg": orderQuotableFlg.value,
                                    disabled: poType.value !== 'PO_NORMAL',
                                    onQuotable: ($event: any) => (detailOrderBtn(body.row))
                                  }, null, 8, ["is-selected", "order-quotable-flg", "disabled", "onQuotable"]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_21))
                          ])
                        ]),
                        _: 2
                      }, 1032, ["class"])
                    ]),
                    "body-cell-url": _withCtx((body) => [
                      _createVNode(_component_q_td, {
                        props: body,
                        class: _normalizeClass(
                    body.row.is_ordered === '1' ||
                    (orderQuotableFlg.value === _unref(OrderQuotableCode).QUOTABLE &&
                      body.row.orderQuotable === _unref(OrderQuotableCode).OTHER)
                      ? 'deleted'
                      : ''
                  )
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            href: body.value,
                            target: "_blank"
                          }, _toDisplayString(body.value), 9, _hoisted_22)
                        ]),
                        _: 2
                      }, 1032, ["props", "class"])
                    ]),
                    "body-cell-sellingPrice": _withCtx((price) => [
                      _createVNode(_component_q_td, {
                        props: price,
                        class: _normalizeClass(
                    price.row.is_ordered === '1' ||
                    (orderQuotableFlg.value === _unref(OrderQuotableCode).QUOTABLE &&
                      price.row.orderQuotable === _unref(OrderQuotableCode).OTHER)
                      ? 'deleted'
                      : ''
                  )
                      }, {
                        default: _withCtx(() => [
                          (price.value === '要問合せ')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_23, "要問合せ"))
                            : (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(price.value), 1))
                        ]),
                        _: 2
                      }, 1032, ["props", "class"])
                    ]),
                    "body-cell": _withCtx((cell) => [
                      _createVNode(_component_q_td, {
                        props: cell,
                        class: _normalizeClass(
                    cell.row.is_ordered === '1' ||
                    (orderQuotableFlg.value === _unref(OrderQuotableCode).QUOTABLE &&
                      cell.row.orderQuotable === _unref(OrderQuotableCode).OTHER)
                      ? 'deleted'
                      : ''
                  )
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(cell.value), 1)
                        ]),
                        _: 2
                      }, 1032, ["props", "class"])
                    ]),
                    _: 1
                  }, 8, ["rows", "columns", "hide-no-data", "pagination-label", "filter", "visible-columns"])
                ], 2),
                (poType.value === 'PO_NORMAL')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, " ※掲載のない容量をご希望の場合、「問合」ボタンよりお問い合わせください。 "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_26, _cache[21] || (_cache[21] = [
                      _createTextVNode(" ※ "),
                      _createElementVNode("img", {
                        class: "order_image",
                        src: "/image/order.gif",
                        alt: "order",
                        style: {"height":"30px","width":"80px"}
                      }, null, -1),
                      _createTextVNode("  の表示がない商品はお見積りが必要なため、カートへ追加は使用できません。 ")
                    ])))
              ]),
              (simularProductDisplayStatus.value !== 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    ref_key: "simularElement",
                    ref: simularElement,
                    class: "similar-product-area q-mt-lg"
                  }, [
                    _cache[22] || (_cache[22] = _createElementVNode("h4", null, "この商品に関する類似品", -1)),
                    (simularProductDisplayStatus.value === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(simDataList.value, (simData, itd) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: itd,
                              class: "result-wrapper"
                            }, [
                              _createVNode(SimilarCard, {
                                result: simData,
                                onOnSimilerDetail: resultSimdataDetail
                              }, null, 8, ["result"])
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_28, "この商品に関する類似品はありません。"))
                  ], 512))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(AlertDialog, {
        display: dialogDispFlg.value,
        level: dialogLevel.value,
        confirmation: "",
        title: dialogTitle.value,
        text: dialogText.value,
        onComplete: _cache[4] || (_cache[4] = ($event: any) => (closeDialog()))
      }, null, 8, ["display", "level", "title", "text"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})